export const getStats = state => state.reports.stats
export const getStatsLoading = state => state.reports.loading
